import * as React from 'react';

class Battery extends React.Component {
  state = {
    batteryLevel: this.props.batteryLevel ? this.props.batteryLevel : 100
  };

  componentDidUpdate(prevProps) {
    if (this.props.batteryLevel !== prevProps.batteryLevel) {
      this.setState({ batteryLevel: this.props.batteryLevel });
    }
  }

  render() {
    const BatteryLevel = () => {
      if (this.state.batteryLevel >= 70) {
        return (
          <path
            d="M5 8.00003C4.44772 8.00003 4 8.44774 4 9.00003V15C4 15.5523 4.44772 16 5 16H17C17.5523 16 18 15.5523 18 15V9.00003C18 8.44774 17.5523 8.00003 17 8.00003H5Z"
            fill="#8A8B8D"
          />
        );
      } else if (this.state.batteryLevel >= 50) {
        return (
          <path
            d="M5 8.00003C4.44772 8.00003 4 8.44774 4 9.00003V15C4 15.5523 4.44772 16 5 16H11C11.5523 16 12 15.5523 12 15V9.00003C12 8.44774 11.5523 8.00003 11 8.00003H5Z"
            fill="#8A8B8D"
          />
        );
      } else {
        return (
          <path
            d="M5 8.00003C4.44772 8.00003 4 8.44774 4 9.00003V15C4 15.5523 4.44772 16 5 16C5.55229 16 6 15.5523 6 15V9.00003C6 8.44774 5.55229 8.00003 5 8.00003Z"
            fill="#8A8B8D"
          />
        );
      }
    };
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g cliprath="url(#clip0_83_31)">
          <BatteryLevel />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.343 4.0197C19.1703 3.99982 18.9793 3.99991 18.7572 4.00001L4.16146 4.00003C3.63431 4.00001 3.17955 4 2.80498 4.0306C2.40963 4.0629 2.01641 4.13422 1.63803 4.32701C1.07355 4.61463 0.614604 5.07357 0.326984 5.63806C0.13419 6.01644 0.0628738 6.40966 0.0305728 6.805C-2.94745e-05 7.17956 -1.54804e-05 7.63429 7.43433e-07 8.16141V15.8386C-1.54804e-05 16.3657 -2.94745e-05 16.8205 0.0305728 17.1951C0.0628738 17.5904 0.13419 17.9836 0.326984 18.362C0.614604 18.9265 1.07355 19.3854 1.63803 19.673C2.01641 19.8658 2.40963 19.9372 2.80498 19.9695C3.17955 20.0001 3.63432 20 4.16148 20L18.7572 20C18.9793 20.0001 19.1703 20.0002 19.343 19.9804C20.7282 19.8209 21.8209 18.7282 21.9803 17.343C22.0002 17.1703 22.0001 16.9793 22 16.7572L22 16.7082C22 16.6618 22 16.6379 22.0003 16.6205L22.0003 16.6183L22.0023 16.6172C22.0178 16.6092 22.0391 16.5985 22.0807 16.5777L23.4472 15.8945C23.786 15.7251 24 15.3788 24 15V9.00003C24 8.62126 23.786 8.27499 23.4472 8.1056L22.0807 7.42232C22.0391 7.40155 22.0178 7.39085 22.0023 7.38281L22.0003 7.38179L22.0003 7.37959C22 7.36213 22 7.33827 22 7.29183L22 7.24286C22.0001 7.02075 22.0002 6.82975 21.9803 6.65702C21.8209 5.27186 20.7282 4.17912 19.343 4.0197ZM18.7082 6.00003C19.007 6.00003 19.0717 6.00168 19.1143 6.00659C19.5761 6.05973 19.9403 6.42397 19.9934 6.88569C19.9983 6.92831 20 6.99302 20 7.29183L20 7.31029C19.9999 7.37743 19.9998 7.46093 20.0065 7.54335C20.0584 8.18368 20.4146 8.76014 20.9642 9.09286C21.0349 9.13568 21.1096 9.17296 21.1697 9.20292L22 9.61806V14.382L21.1697 14.7971C21.1096 14.8271 21.0349 14.8644 20.9642 14.9072C20.4146 15.2399 20.0584 15.8164 20.0065 16.4567C19.9998 16.5391 19.9999 16.6226 20 16.6898L20 16.7082C20 17.007 19.9983 17.0717 19.9934 17.1144C19.9403 17.5761 19.5761 17.9403 19.1143 17.9935C19.0717 17.9984 19.007 18 18.7082 18H4.2C3.62345 18 3.25118 17.9993 2.96784 17.9761C2.69618 17.9539 2.59546 17.9162 2.54601 17.891C2.35785 17.7952 2.20487 17.6422 2.109 17.454C2.0838 17.4046 2.04613 17.3039 2.02393 17.0322C2.00078 16.7489 2 16.3766 2 15.8V8.20003C2 7.62348 2.00078 7.2512 2.02393 6.96787C2.04613 6.6962 2.0838 6.59548 2.109 6.54604C2.20487 6.35788 2.35785 6.2049 2.54601 6.10902C2.59546 6.08383 2.69618 6.04615 2.96784 6.02396C3.25118 6.00081 3.62345 6.00003 4.2 6.00003H18.7082Z"
            fill="#8A8B8D"
          />
        </g>
        <defs>
          <clipPath id="clip0_83_31">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default Battery;
